import InitialState from "../../InitialState";
import * as types from "./ActionTypes";

export default function instructorProgrammingReducer(state = InitialState.instructorProgramming, action) {
    switch(action.type) {
        case types.INSTRUCTOR_UPDATE_SELECTED_LAB:
            return {
                selected_lab: action.payload.data,
                //selected_program: null,
                //selected_submission: null
            }
        
        case types.INSTRUCTOR_UPDATE_SELECTED_PROGRAM:
            return {
                ...state,
                selected_program: action.payload.data,
                //selected_submission: null
            }
        
        case types.INSTRUCTOR_UPDATE_SELECTED_SUBMISSION:
            return {
                ...state,
                selected_submission: action.payload.data
            }

        case types.INSTRUCTOR_UPDATE_SELECTED_COURSE:
            return {
                ...state,
                selected_course: action.payload.data,
            }

        default: 
            return state
    }
}